import React from 'react';
import { motion } from 'framer-motion';
import { Check, Clock, Gift } from 'lucide-react';
export function Pricing() {
  return <section className="py-24 bg-white text-[#1a1a2e] relative overflow-hidden" data-id="element-174">
      {/* Geometric background accents */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gray-50 -z-10 transform rotate-45 translate-x-32 -translate-y-32" data-id="element-175" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gray-50 -z-10 transform -rotate-12 -translate-x-32 translate-y-32" data-id="element-176" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-white border-2 border-[#0c1222] p-8 md:p-12 shadow-2xl" data-id="element-178">
          {/* Urgency Badge */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#c0392b] px-6 py-2 shadow-lg" data-id="element-179">
            <span className="text-white font-bold uppercase tracking-widest text-sm md:text-base whitespace-nowrap" data-id="element-180">
              Oferta Por Tiempo Limitado
            </span>
          </div>

          <div className="text-center mt-8 mb-12" data-id="element-181">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0c1222] mb-4" data-id="element-182">
              Protege a tu familia hoy mismo
            </h2>
            <p className="text-gray-600 font-sans max-w-lg mx-auto" data-id="element-183">
              Precio especial de lanzamiento — menos de lo que cuesta una
              consulta legal de 15 minutos.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-10" data-id="element-184">
            <div className="text-center" data-id="element-185">
              <span className="block text-gray-400 text-2xl line-through font-serif decoration-[#c0392b] decoration-2" data-id="element-186">
                $29 USD
              </span>
              <motion.div initial={{
              scale: 0.8,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3,
              type: 'spring',
              stiffness: 200
            }} className="text-[#c0392b] font-serif font-black text-7xl md:text-8xl leading-none" data-id="element-187">
                $6.39
              </motion.div>
              <span className="text-sm text-gray-500 font-sans uppercase tracking-wide mt-2 block" data-id="element-188">
                Pago único
              </span>
            </div>

            <div className="w-full md:w-auto h-px md:h-32 bg-gray-200 md:w-px" data-id="element-189" />

            <ul className="space-y-4 text-left" data-id="element-190">
              {['Guía completa en PDF con anexos imprimibles', '8 plantillas para rellenar incluidas', 'Lista de recursos gratuitos', 'Actualizaciones 2026 incluidas', 'Acceso inmediato en PDF'].map((item, i) => <li key={i} className="flex items-center text-[#0c1222] font-sans font-medium" data-id="element-191">
                  <Check className="w-5 h-5 text-[#c0392b] mr-3 flex-shrink-0" data-id="element-192" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Bonus Box */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="relative bg-[#0c1222] text-white p-6 md:p-8 mb-10 border border-[#c0392b]/30" data-id="element-193">
            <div className="absolute -top-3 left-6 bg-[#c0392b] px-4 py-1" data-id="element-194">
              <span className="text-white font-bold text-xs uppercase tracking-widest font-sans flex items-center gap-2" data-id="element-195">
                <Gift className="w-3.5 h-3.5" data-id="element-196" />
                Bonus Incluido
              </span>
            </div>
            <p className="font-sans text-sm sm:text-base leading-relaxed text-gray-200 mt-2" data-id="element-197">
              Además de la guía principal, recibirás un set exclusivo de{' '}
              <strong className="text-white" data-id="element-198">8 imprimibles prácticos</strong>:
              plantillas personalizables para tu checklist de emergencia, hoja
              de contactos clave, plan familiar de acción inmediata y más.{' '}
              <span className="text-[#c0392b] font-semibold" data-id="element-199">
                Todo listo para imprimir, rellenar y proteger a tu familia desde
                hoy.
              </span>
            </p>
          </motion.div>

          <div className="text-center" data-id="element-200">
            <motion.a href="https://neurolecturaspro.com/cart/46679258759403:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full md:w-auto bg-[#c0392b] text-white font-bold text-xl px-12 py-5 uppercase tracking-widest hover:bg-[#a93226] transition-colors shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#c0392b] inline-block text-center" data-id="element-201">
              DESCARGAR MI GUÍA Y BONOS AHORA
            </motion.a>

            <div className="mt-6 flex flex-col items-center justify-center space-y-2 text-sm text-gray-500 font-sans" data-id="element-202">
              <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-center" data-id="element-203">
                <span data-id="element-204">Descarga inmediata</span>
                <span className="hidden sm:block w-1 h-1 bg-gray-400 rounded-full" data-id="element-205" />
                <span data-id="element-206">Formato digital</span>
                <span className="hidden sm:block w-1 h-1 bg-gray-400 rounded-full" data-id="element-207" />
                <span data-id="element-208">Garantía de 7 días</span>
              </div>

              <div className="flex items-center text-[#c0392b] font-bold mt-4 animate-pulse" data-id="element-209">
                <Clock className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-210" />
                <span data-id="element-211">Quedan pocas copias a este precio</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}